<template>
  <div id="detail-component">
    <default-event-detail
      v-if="getGameConsole === 'default'"
    ></default-event-detail>
    <market-view-detail
      v-if="getGameConsole === 'marketview'"
    ></market-view-detail>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import DefaultEventDetail from '@/components/center_widgets/Previews/DefaultEventDetail'
import MarketViewDetail from '@/components/center_widgets/Previews/MarketViewDetail'

export default {
  name: 'Detail',
  components: {
    DefaultEventDetail,
    MarketViewDetail,
  },
  data: () => ({}),
  computed: {
    ...mapGetters({
      getGameConsole: 'settings/getGameConsole',
    }),
  },
}
</script>

<style></style>
